import React from 'react';
import styled from 'styled-components';
import {ArrowDown, BuildingDomestic} from 'components/Ui/Icon';
import {useHistory} from 'react-router-dom';
import {useCurrentClientQuery} from 'api';
import {Button, Dropdown, Menu} from 'components/antd';
import {Eye} from 'components/Ui/Icon';
import ColumnPopover from './ColumnPopover';

export default () => {
  return (
    <Container>
      <Dropdown
        placement="bottomRight"
        trigger={['click']}
        overlay={<ColumnPopover />}>
        <Button type="ghost">
          <div className="mt-1 mr-2">
            <Eye />
          </div>
          表示項目初期設定 <ArrowDown />
        </Button>
      </Dropdown>
    </Container>
  );
};

const Container = styled.div`
  .ant-btn-ghost {
    display: flex;
    align-items: center;
    border: 1px solid #bdc4cb;
    border-radius: 4px;
    color: #495058;
    font-weight: 700;
    padding: 5.6px 10px;

    svg {
      width: 14px;
      height: 14px;
      margin-left: 8px;
    }
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;

  > div:first-child {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: #e2e6ea;
    border-radius: 4px;
    margin-right: 7px;

    svg {
      width: 13px;
      height: 13px;
    }
  }
`;
